export const isPPLClient = () => {
  return process.env.CLIENT === 'ct-ppl' || import.meta.env?.VITE_CLIENT === 'ct-ppl';
};
